export const THIRTY_MINUTES = 1800000;
export const TWO_MINUTES = 120000;

